import { Container, Typography } from "@/components/atoms";

interface BookingUnavailableProps {
  title?: string;
  message?: string;
}

/**
 * Full-height "can't start this booking" surface. Shared by the guest flow (invalid/expired quote) and
 * the authenticated widget hand-off (logged-in user who doesn't belong to the quote's operator, or an
 * unresolvable quote). The default copy matches the original guest not-available state.
 */
export const BookingUnavailable = ({ title = "Booking unavailable", message }: BookingUnavailableProps) => (
  <Container className="flex flex-1 flex-col items-center justify-center gap-2 py-20 text-center">
    <Typography variant="h2">{title}</Typography>
    <Typography variant="paragraph" className="text-neutral-dark-gray">
      {message ?? "This booking link is invalid or has expired. Please start a new quote and try again."}
    </Typography>
  </Container>
);
